module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-root wrapper",
    attrs: {
      "id": "app"
    }
  }, [_c('initializer', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "update:loading": function($event) {
        _vm.loading = $event
      }
    }
  }), (!_vm.loading) ? [_c('app-header'), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b61cc35"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/App.vue
// module id = 944
// module chunks = 1